import { MetricCard } from "../components/MetricCard";
import { Button } from "../components/ui/Button";
import { Card } from "../components/ui/Card";

export function HomePage() {
  return (
    <Card className="p-8">
      <p className="text-xs font-black uppercase tracking-[.28em] text-slate-500">Production product surface map</p>
      <h1 className="mt-4 max-w-4xl text-5xl font-black tracking-tight text-slate-950">Violet Exchange full frontend app shell.</h1>
      <p className="mt-4 max-w-3xl text-lg text-slate-600">React routes, Tailwind design system, mock services, and production-oriented source boundaries are now in place for the marketplace buildout.</p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Button href="/marketplace">Open marketplace</Button>
        <Button href="/auth/register" variant="secondary">Start registration</Button>
      </div>
      <div className="mt-8 grid gap-4 md:grid-cols-3">
        <MetricCard label="Pages planned" value="32" />
        <MetricCard label="Source boundaries" value="8" />
        <MetricCard label="Current data mode" value="Mock" />
      </div>
    </Card>
  );
}
